type Success<T> = {
  data: T;
  error: null;
};

type Failure<E> = {
  data: null;
  error: E;
};

type Result<T, E = Error> = Success<T> | Failure<E>;

export const tryCatch = async <T, E = Error>(
  work: Promise<T> | (() => T | Promise<T>),
): Promise<Result<T, E>> => {
  try {
    const data = await (typeof work === 'function' ? work() : work);
    return { data, error: null };
  } catch (error) {
    return { data: null, error: error as E };
  }
};

export const tryCatchSync = <T, E = Error>(work: () => T): Result<T, E> => {
  try {
    return { data: work(), error: null };
  } catch (error) {
    return { data: null, error: error as E };
  }
};
